import React, { useState } from 'react';
import Tooltip from '../../../../../muiComponents/Tooltip';
import UnsavedServicesChangesPopUp from './UnsavedServicesChangesPopUp';
import IconButton from '../../../../../muiComponents/IconButton';

interface BackToPropertiesButtonProps {
    isLoading: boolean;
    hasUnsavedChanges: boolean;
    onClick: () => void;
    onSave: () => Promise<void>;
}

const BackToPropertiesButton = ({
    isLoading,
    hasUnsavedChanges,
    onClick,
    onSave,
}: BackToPropertiesButtonProps) => {
    const [isWarningOpen, setIsWarningOpen] = useState(false);

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (isLoading) {
            e.preventDefault();
            return;
        }

        if (hasUnsavedChanges) {
            e.preventDefault();
            setIsWarningOpen(true);
        } else {
            onClick();
        }
    };

    return (
        <>
            <Tooltip titleText={'back_to_properties'}>
                <span>
                    <IconButton
                        iconName={'ArrowBack'}
                        role='button'
                        size='small'
                        onClick={handleClick}
                        className={`zitoneo-header__hotel-selector__back`}
                    />
                </span>
            </Tooltip>
            <UnsavedServicesChangesPopUp
                isOpen={isWarningOpen}
                onClose={() => {
                    setIsWarningOpen(false);
                    onClick();
                }}
                onSave={async () => {
                    await onSave();
                    setIsWarningOpen(false);
                }}
            />
        </>
    );
};

export default BackToPropertiesButton;
